import { render, staticRenderFns } from "./Media_source_editor.vue?vue&type=template&id=18adec86"
import script from "./Media_source_editor.vue?vue&type=script&lang=js"
export * from "./Media_source_editor.vue?vue&type=script&lang=js"
import style0 from "./Media_source_editor.vue?vue&type=style&index=0&id=18adec86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports